import { grey } from '../../utils/brandColors';

export default () => ({
  container: { margin: '0 0 1rem' },
  icon: { padding: 5 },
  label: {
    color: grey[600],
    lineHeight: 0,
  },
});
